import { Link } from "react-router-dom";
import { formatDate } from "../../utils/helps";
import { getExcerpt } from "../../utils/html";

const ArticleBox = ({ article }) => {
  const imageUrl = article?.images?.[0]?.url
    ? `${process.env.REACT_APP_API_URL}media/${article.images[0].url}`
    : "/placeholder.jpg";

  return (
    <div className="group flex flex-col">
      <Link to={`/post/${article?.slug}`}>
        <div className="w-full aspect-[4/3] overflow-hidden mb-3">
          <img
            src={imageUrl}
            alt={article?.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
        </div>
        <h2 className="text-base md:text-lg font-semibold leading-snug group-hover:text-blue-700 transition-colors duration-300 line-clamp-3">
          {article?.title}
        </h2>
        <p className="text-xs text-gray-500 mt-1">
          {formatDate(article?.createdAt)}
        </p>
        <p className="text-sm text-gray-700 mt-2 line-clamp-3 text-justify">
          {article?.summary || getExcerpt(article?.content)}
        </p>
      </Link>
    </div>
  );
};

export default ArticleBox;
